// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e69f7262","239":"268e02b5","453":"c25f80db","732":"0d6c0a8e","867":"2aa30c9f"}[chunkId] + ".chunk.js";
};